const global = window

inputs.alias.steps = 'tabs'

inputs.fn.tabs = {
    /**
     * Résout l'index (0-based) d'un onglet à partir d'un sélecteur, élément, valeur ou index
     */
    findIndex(input, tab) {
        input = $(input);
        if (!input.hasClass('tabs')) {
            input = input.closest('.tabs');
        }

        if (tab === null || tab === undefined) return null;

        // Si c'est un objet jQuery ou élément DOM
        if (typeof tab === 'object') {
            tab = $(tab);
            if (tab.hasClass('tabs')) {
                tab = tab.find('> .tabs__nav, > .tabs__nav__wrap > .tabs__nav');
            }
            if (tab.hasClass('tabs__btn')) {
                let controls = tab.attr('aria-controls');
                if (controls) {
                    tab = $('#' + controls);
                } else {
                    return tab.index();
                }
            }
            if (!tab.hasClass('tabs__pane')) {
                tab = tab.closest('.tabs__nav');
            }
            if (tab.hasClass('tabs__pane')) {
                const paneId = tab.attr('id');
                const btn = tab.parent().find('.tabs__nav').find(
                    '[aria-controls="' + paneId + '"], #btn-' + paneId + ', #btn-' + tab.attr('data-id') + ', #btn-' + tab.attr('name')
                );
                if (btn.length) {
                    return btn.index();
                }
                return tab.index('.tabs__pane');
            }
            return null;
        }

        // Si c'est une valeur / identifiant
        const targetBtn = input.find('.tabs__nav').find('.tabs__btn[data-value="' + tab + '"], .tabs__btn[value="' + tab + '"]');
        if (targetBtn.length) {
            return targetBtn.index();
        }

        let targetPane = input.find('> .tabs__pane[data-value="' + tab + '"], > .tabs__pane[value="' + tab + '"], > .tabs__pane[data-id="' + tab + '"], > .tabs__pane[id="' + tab + '"], > .tabs__pane[name="' + tab + '"]');
        if (!targetPane.length) {
            targetPane = input.find('.tabs__pane').filter(function() {
                return $(this).attr('data-value') == tab || $(this).attr('value') == tab || $(this).attr('data-id') == tab || $(this).attr('id') == tab || $(this).attr('name') == tab;
            });
        }

        if (targetPane.length) {
            const paneId = targetPane.attr('id');
            const btn = input.find('.tabs__nav').find(
                '[aria-controls="' + paneId + '"], [data-value="' + tab + '"], #btn-' + paneId + ', #btn-' + targetPane.attr('data-id') + ', #btn-' + targetPane.attr('name')
            );
            if (btn.length) {
                return btn.index();
            }
            return targetPane.index('.tabs__pane');
        }

        if (!isNaN(tab) && tab !== '') {
            return parseInt(tab, 10);
        }

        return null;
    },

    /**
     * Active un onglet spécifique
     */
    set(input, tab) {
        input = $(input);
        if (!input.hasClass('tabs')) {
            input = input.closest('.tabs');
        }

        const tabIndex = this.findIndex(input, tab);
        if (input.length && tabIndex !== null && tabIndex >= 0) {
            input.tabs('option', 'active', tabIndex);
        }
    },

    /**
     * Récupère la valeur active d'un composant tabs
     */
    getActiveValue(input, panel) {
        input = $(input);
        const currentTab = input.find(' > ul .ui-tabs-active, > .tabs__nav__wrap > ul .ui-tabs-active');
        let activePane = (panel && panel.length) ? panel : $('#' + currentTab.attr('aria-controls'));
        if (!activePane.length) {
            activePane = input.find('.tabs__pane').eq(currentTab.index());
        }

        let tabVal = activePane.attr('data-value') || activePane.attr('value') || currentTab.attr('data-value');
        if (tabVal === undefined || tabVal === null || tabVal === '') {
            tabVal = currentTab.index();
        }
        return tabVal;
    },

    /**
     * Récupère l'onglet sauvegardé en mémoire locale ou en session
     */
    getSavedTab(input, data) {
        input = $(input);
        let memoryKey = input.attr('data-memory') || (data && data.memory) || input.data('memory') || input.data('memory-key');
        if (memoryKey === true || memoryKey === 1 || memoryKey === '1') {
            const formName = (data && data.form && data.form.name) ? data.form.name + '_' : '';
            const fieldName = (data && data.name) ? data.name : (input.attr('name') || input.attr('id') || 'tabs');
            memoryKey = 'field_' + formName + fieldName;
        } else if (typeof memoryKey === 'string' && !memoryKey.startsWith('field_')) {
            memoryKey = 'field_' + memoryKey;
        }

        if (memoryKey) {
            try {
                const saved = localStorage.getItem(memoryKey);
                if (saved !== null && saved !== undefined && saved !== '') {
                    return saved;
                }
            } catch(e) {}
        }

        const inputName = input.attr('name');
        if (inputName && global.selectedTabsRecords && global.selectedTabsRecords[inputName] !== undefined && global.selectedTabsRecords[inputName] !== null) {
            return global.selectedTabsRecords[inputName];
        }

        return null;
    },

    /**
     * Fait défiler le bouton d'onglet dans le champ de vision
     */
    scrollIntoView(currentTab) {
        if (!currentTab || !currentTab.length) return;
        const tabWrap = currentTab.closest('.tabs__nav__wrap');
        if (!tabWrap.length) return;

        const wrapEl = tabWrap[0];
        const tabEl = currentTab[0];
        const wrapRect = wrapEl.getBoundingClientRect();
        const tabRect = tabEl.getBoundingClientRect();
        const offsetMargin = 30;

        if (tabRect.left < wrapRect.left) {
            const scrollDiff = tabRect.left - wrapRect.left - offsetMargin;
            wrapEl.scrollTo({
                left: Math.max(0, wrapEl.scrollLeft + scrollDiff),
                behavior: 'smooth'
            });
        } else if (tabRect.right > wrapRect.right) {
            const scrollDiff = tabRect.right - wrapRect.right + offsetMargin;
            wrapEl.scrollTo({
                left: Math.min(wrapEl.scrollWidth - wrapEl.clientWidth, wrapEl.scrollLeft + scrollDiff),
                behavior: 'smooth'
            });
        }
    },

    /**
     * Ajuste la visibilité de la barre d'onglets si moins de 2 onglets sont présents
     */
    adjustSingleTabVisibility(tabsEl) {
        const nav = $(tabsEl).find('.tabs__nav');
        if (nav.children('.tabs__btn').length < 2) {
            nav.addClass('tabs__nav--notabs');
            if (nav.children('.tabs__addon').length) {
                nav.children('.tabs__btn').hide();
            } else {
                nav.hide();
            }
        }
    }
}

inputs.types.tabs = function (data, name, niceName, type, input, parent, inputWindow) {

    data.activate = function(event, ui) {
        const panel = (ui && ui.newPanel) ? ui.newPanel : ui.panel;
        const tabData = panel ? panel.data('data') : null;

        // Flex pour pleine hauteur
        if (panel && tabData && tabData.full) panel.css("display", "flex");

        // Changer valeur
        const currentTab = $(input).find(' > ul .ui-tabs-active, > .tabs__nav__wrap > ul .ui-tabs-active');
        const tabVal = inputs.fn.tabs.getActiveValue(input, panel);

        $(input).val(tabVal).attr('value', tabVal);

        // Hack IV
        if (panel) {
            panel.find('.iv').each(function () {
                let tabIvPlugin = $(input).data('plugin')
                if (tabIvPlugin && tabIvPlugin.resize) {
                    tabIvPlugin.resize()
                }
            })
        }

        // Mise à jour grandeur de fenêtre
        if (tabData) {
            const newWidth = tabData.width
            const newHeight = tabData.height
            if (newWidth || newHeight) {
                const win = $.window.find(input)
                if (win) {
                    win.resize(newWidth, newHeight)
                    win.alignCenter()
                }
            }
        }

        // Couleur de l'onglet
        let activePane = (panel && panel.length) ? panel : $('#' + currentTab.attr('aria-controls'));
        const tabColor = (tabData && tabData.color) || (activePane && (activePane.attr('color') || activePane.data('color'))) || (currentTab && (currentTab.attr('color') || currentTab.data('color')));
        $(input).css('--color-primary', tabColor || '');

        // Save tabs
        if ($(input).attr('name') && tabVal !== undefined && tabVal !== null) {
            global.selectedTabsRecords[$(input).attr('name')] = tabVal;
        }

        // Scroll tab into view if needed within .tabs__nav__wrap
        inputs.fn.tabs.scrollIntoView(currentTab);

        // Apply behavior
        if (panel) BEHAV.apply(panel, 'show');

        // Resize trigger
        window.dispatchEvent(new Event('resize'));

        // Change event only if value changed or triggered by user event
        if (event && event.originalEvent) {
            $(input).change();
        }
    };

    // Résoudre l'onglet initial sauvegardé
    const initialTab = inputs.fn.tabs.getSavedTab(input, data);
    let initialIndex = (initialTab !== null && initialTab !== undefined) ? inputs.fn.tabs.findIndex(input, initialTab) : 0;
    if (initialIndex === null || initialIndex < 0 || isNaN(initialIndex)) {
        initialIndex = 0;
    }

    input.tabs({
        active: initialIndex,
        activate: data.activate,
        create(event, ui) {
            const tabVal = inputs.fn.tabs.getActiveValue(this, ui && ui.panel);
            $(this).val(tabVal).attr('value', tabVal);
            inputs.fn.tabs.adjustSingleTabVisibility(event.target);
        },
        beforeLoad(event, ui) {
            // disable AJAX loading
            event.preventDefault();
        }
    });

    input.tabs("option", "classes.ui-tabs", "tabs");
    input.tabs("option", "classes.ui-tabs-nav", "tabs__nav");
    input.tabs("option", "classes.ui-tabs-panel", "tabs__pane");
    input.tabs("option", "classes.ui-tabs-tab", "tabs__btn");

    return data;
}
